function Payment(){

}

export default Payment;